import { render, staticRenderFns } from "./VTreeViewItem.vue?vue&type=template&id=dbecd860&"
import script from "./VTreeViewItem.vue?vue&type=script&lang=js&"
export * from "./VTreeViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports